import React, { useEffect, useState } from 'react';
import BossDialog from '../../components/BossDialog';
import RoundButton from '../../framework/forms/helpercomponents/buttons/RoundButton';
import ActionButton from '../../framework/forms/helpercomponents/buttons/ActionButton';
import * as API from '../../framework/API/api';
import InsightCard from './InsightCard';
import ToastNotification from "../../components/ToastNotification";
import { TOAST_TYPES } from '../../framework/constant/constant';
import { useTranslation } from '../../locale/useTranslation';

const MetaInsightsForm = ({ item = {}, pageId, platform, onClose, savedInsights = null}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [basicInfo, setBasicInfo] = useState({});
    const [insights, setInsights] = useState([]);
    const lang = useTranslation();

    useEffect(() => {
        if (savedInsights) {
            loadSavedInsights(savedInsights);
        } else {
            loadInsights();
        }
    }, [item]);

    const loadSavedInsights = (data) => {
        setIsLoading(true);
        const insightData = data ?? {};
        const basicInfo = insightData.basicInfo ?? {};
        const insights = Array.isArray(insightData.insights) ? insightData.insights : [];
        setBasicInfo(basicInfo);
        setInsights(insights);
        setIsLoading(false);
    };

    const loadInsights = async () => {
        setIsLoading(true);
        const payload = {
            pageId: pageId,
            postId: item?.postId,
            platform: platform
        };

        const res = await API.getSocialMediaPromotionPostInsights(payload);
        if (res?.success) {
            const insightData = res.data?.data || res.data || {};
            setBasicInfo(insightData.basicInfo || {});
            setInsights(insightData.insights || []);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: "Error", message: res?.message || "Failed to fetch post insights" });
        }
        setIsLoading(false);
    };

    const metricIcons = {
        likes: "❤️",
        comments: "💬",
        views: "👁️",
        reach: "📡",
        saved: "🔖",
        shares: "📤",
        video_views: "🎥",
        total_interactions: "🤝",
        profile_visits: "👤",
        follows: "➕",
        impressions: "📈"
    };

    const capitalize = (text = "") =>
        text
            .replace(/_/g, " ")
            .replace(/\b\w/g, c => c.toUpperCase());

    const summaryData = [
        {
            label: `${lang.likes_label} ${metricIcons.likes}`,
            value: basicInfo?.like_count ?? 0
        },
        {
            label: `${lang.comments_label} ${metricIcons.comments}`,
            value: basicInfo?.comments_count ?? 0
        },
        ...insights.map(i => ({
            label: `${capitalize(i.name)} ${metricIcons[i.name] || "📊"}`,
            value: i.value ?? 0
        }))
    ];

    return (
        <BossDialog title={lang.insight_dialog_header} height="auto" width={"650px"} zIndex={1050} onClose={onClose}>
            {!savedInsights && (
                <div className='d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom'>
                    <div className='d-flex align-items-center'>
                        <RoundButton onClick={loadInsights} title="Refresh Insights" icon="refresh" />
                        <span className="text-dark fw-bold" style={{ marginLeft: '8px', fontSize: '15px' }}>{lang.get_latest_insights_label}</span>
                    </div>
                    {basicInfo?.permalink && (
                        <div style={{ marginTop: '3px' }}>
                            <ActionButton
                                name={lang.view_on_instagram_label}
                                btnColor="primary"
                                onClick={() => window.open(basicInfo.permalink, '_blank')}
                            />
                        </div>
                    )}
                </div>
            )}

            {isLoading ? (
                <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status"></div>
                    <p className="text-muted mt-2">Fetching live Instagram insights...</p>
                </div>
            ) : (
                <>
                    <div className='fw-bold text-dark mb-2'>{lang.analytics_label}</div>

                        <div
                            className='border rounded p-3'
                            style={{
                                background: '#F8F9FA'
                            }}
                        >
                            <InsightCard
                                data={summaryData}
                                containerStyle={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(2, 1fr)',
                                    gap: '12px'
                                }}
                                cardStyle={{
                                    minWidth: 'unset',
                                    width: '100%',
                                    padding: '14px 10px',
                                    borderTop: '3px solid #0d6efd',
                                    borderRadius: '8px',
                                    background: '#fff',
                                    boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
                                    textAlign: 'center'
                                }}
                                titleStyle={{
                                    fontSize: '15px',
                                    color: '#6c757d',
                                    marginBottom: '6px'
                                }}
                                itemStyle={{
                                    fontSize: '28px',
                                    fontWeight: '700',
                                    color: '#212529'
                                }}
                            />
                        </div>
                </>
            )}
        </BossDialog>
    );
};

export default MetaInsightsForm;
